export default __webpack_public_path__ + "static/media/A Case for Adoption Rights for LGBTQ Community - Sanjay Gadkari.3ce710b1.pdf";